import { createSelector } from '@reduxjs/toolkit';
import { RootState } from '../../../store';
import { ImageDTO, PaginationParams } from '../../types/apiType';
import { BookFilter, Contributor, ImageState } from './ImageSlice';

const selectImage = (state: RootState) => state.image as ImageState;

export const selectImagesList = createSelector(selectImage, (image) => image.list as ImageDTO[]);
export const selectCurrentImage = createSelector(selectImage, (image) => image.currentImage as ImageDTO);
export const selectPagination = createSelector(selectImage, (image) => image.pagination as PaginationParams);
export const selectLoadingImage = createSelector(selectImage, (image) => image.loading as boolean);
export const selectContributor = createSelector(selectImage, (image) => image.contributors as Contributor[]);
export const selectSelectedImage = createSelector(selectImage, (image) => image.selectedImages as string[]);
export const selectBooksFilter = createSelector(selectImage, (image) => image.books as BookFilter[]);
